import axios from "axios";

export const GET_FORMATION_CATEGORIES = "GET_FORMATION_CATEGORIES";
export const ADD_FORMATION_CATEGORY = "ADD_FORMATION_CATEGORY";
export const EDIT_FORMATION_CATEGORY = "EDIT_FORMATION_CATEGORY";
export const DELETE_FORMATION_CATEGORY = "DELETE_FORMATION_CATEGORY";

const API = `${process.env.REACT_APP_API_URL}/api/categories`;

export const getFormationCategories = () => async (dispatch) => {
  try {
    const res = await axios.get(API, { withCredentials: true });
    dispatch({ type: GET_FORMATION_CATEGORIES, payload: res.data });
  } catch (error) {
    console.error(error);
  }
};

export const createFormationCategory = (name) => async (dispatch) => {
  const res = await axios({
    method: "post",
    url: API,
    withCredentials: true,
    data: { name },
  });
  dispatch({ type: ADD_FORMATION_CATEGORY, payload: res.data });
  return res.data;
};

export const editFormationCategory = (id, name) => async (dispatch) => {
  const res = await axios({
    method: "put",
    url: `${API}/${id}`,
    withCredentials: true,
    data: { name },
  });
  dispatch({ type: EDIT_FORMATION_CATEGORY, payload: res.data });
  return res.data;
};

// Ne PAS avaler l'erreur : le 409 (catégorie utilisée) doit remonter à l'UI
export const deleteFormationCategory = (id) => async (dispatch) => {
  await axios({
    method: "delete",
    url: `${API}/${id}`,
    withCredentials: true,
  });
  dispatch({ type: DELETE_FORMATION_CATEGORY, payload: { id } });
};
